import {Form, Formik, useFormikContext} from 'formik'
import {useState} from 'react'
import {InlineTable} from 'src/feature/bite/component'
import {useUpdateProvider} from 'src/feature/provider/context/useMutation'
import * as Yup from 'yup'
import {ConnectedFocusError} from 'focus-formik-error'

const SocialMedia = ({
  loading,
  intl,
  editable,
  setEditable,
}: {
  loading: boolean
  intl: any
  editable: any
  setEditable: any
}) => {
  const {handleSubmit, values, resetForm, initialValues} = useFormikContext() as any

  const column = [
    [
      {
        key: 'facebook',
        dataIndex: 'facebook',
        title: 'Facebook',
        edit: 'input',
        maxLength: 75,
        tooltip: 'Enter the link of your Facebook profile or business page.',
      },
      {
        key: 'linkedIn',
        dataIndex: 'linkedIn',
        title: 'LinkedIn',
        edit: 'input',
        maxLength: 75,
        tooltip: 'Add your LinkedIn profile link.',
      },
    ],
    [
      {
        key: 'instagram',
        dataIndex: 'instagram',
        title: 'Instagram',
        edit: 'input',
        maxLength: 75,
        tooltip: 'Provide the link to your Instagram account.',
      },
      {
        key: 'twitter',
        dataIndex: 'twitter',
        title: 'Twitter',
        edit: 'input',
        tooltip: 'Enter your Twitter (X) profile link.',
        maxLength: 75,
      },
    ],
  ]

  const validationSchema = Yup.object().shape({})

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>{intl.formatMessage({id: 'GLOBAL.SOCIAL_MEDIA'})}</h3>
            <p className='text-muted fw-normal fs-6'>
              Add links to your professional social media profiles.
            </p>
          </div>
        </div>
      </div>

      <div className='card-body p-9'>
        <InlineTable
          loading={loading}
          dataSource={initialValues}
          columns={column}
          editable={editable.socialMedia}
          values={values}
        />
      </div>

      <div className='card-footer d-flex w-100 justify-content-end'>
        {editable.socialMedia ? (
          <div>
            <button
              className='btn btn-primary'
              style={{marginRight: 10}}
              onClick={() => {
                setEditable({
                  overview: false,
                  professionalDetails: false,
                  serviceDetails: false,
                  socialMedia: false,
                  contractDetails: false,
                  financialDetails: false,
                })
                resetForm()
              }}
            >
              <i className='bi bi-x me-2'></i>
              {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
            </button>
            <button
              className='btn btn-primary'
              disabled={loading}
              type='button'
              onClick={async (e) => {
                values.type = 3
                await handleSubmit()
              }}
            >
              <i className='bi bi-save2 me-2'></i>
              {loading
                ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
            </button>
          </div>
        ) : (
          <button
            className='btn btn-primary'
            onClick={() => {
              resetForm()
              setEditable({
                overview: false,
                professionalDetails: false,
                serviceDetails: false,
                socialMedia: true,
                contractDetails: false,
                financialDetails: false,
              })
            }}
          >
            <i className='bi bi-pencil me-2'></i>
            {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
          </button>
        )}
      </div>
    </div>
  )
}

export default SocialMedia
